import { css, jsx } from '@emotion/react';
import { Colors, Text, Icon, Typography } from '@zapier/design-system';
import { useRef } from 'react';
import { useButton } from 'react-aria';
import { Popover as Popover$1, Dialog } from 'react-aria-components';

const PopoverStyles = ({ color }) => css([
  Typography.Body1,
  Object.assign(Object.assign({ background: color === "light" ? `${Colors.BackgroundDefault}` : `var(--zds-gray-warm-10, ${Colors.GrayWarm10})`, color: `var(--zds-gray-warm-1, ${Colors.GrayWarm1})`, width: "max-content", maxWidth: "300px" }, Typography.Body1Multiline), { borderRadius: "var(--zds-radius-medium, 10px)", padding: "var(--zds-space-4, 16px) var(--zds-space-8, 14px)" })
]);
const getPopoverContentCss = (color) => css`
  p {
    margin-bottom: 0;
  }

  a {
    color: ${color === "dark" ? Colors.GrayWarm1 : Colors.GrayWarm10};
  }

  code {
    color: ${color === "dark" ? Colors.GrayWarm3 : Colors.GrayWarm6};
  }
`;
const closeButton = css`
  background-color: ${Colors.transparent};
  border: none;
  cursor: pointer;
  padding: 0;
`;
const popoverHeaderLayoutCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  min-height: 10px;
`;
const popoverContentScrollContainerCss = css`
  max-height: 150px;
  overflow: auto;
`;
const Popover = ({ children, color = "dark", placement = "bottom", isOpen, onOpenChange, shouldCloseOnInteractOutside, triggerRef, title }) => {
  const ref = useRef(null);
  const { buttonProps } = useButton({ onPress: () => onOpenChange && onOpenChange(false) }, ref);
  return jsx(
    Popover$1,
    { css: PopoverStyles({ color: color || "dark" }), triggerRef, placement, shouldCloseOnInteractOutside, isOpen, onOpenChange },
    jsx(
      Dialog,
      null,
      jsx(
        Text,
        { type: "SmallPrint3", color: "GrayWarm1" },
        jsx(
          "div",
          { css: popoverHeaderLayoutCss },
          jsx(Text, { type: "SmallPrint2", color: color === "dark" ? "BrandLavender" : "UiPrimaryStronger", tag: "div" }, title),
          jsx(
            "button",
            Object.assign({ ref }, buttonProps, { css: closeButton, type: "button" }),
            jsx(Icon, { isBlock: true, name: "formX", size: 16, color: color === "dark" ? "GrayWarm1" : "GrayWarm10" })
          )
        ),
        jsx(
          "div",
          { css: popoverContentScrollContainerCss },
          jsx("div", { css: getPopoverContentCss(color) }, children)
        )
      )
    )
  );
};

export { Popover };
//# sourceMappingURL=Popover.es.js.map
